import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import navigation from "../../../menu-items";
import configs from "../../../config";

const Breadcrumb = () => {
   const [item, setItem] = useState([]);
   const location = useLocation();

   useEffect(() => {
      const getCollapse = (item) => {
         if (item.children) {
            item.children.filter((collapse) => {
               if (collapse.type && collapse.type === "collapse") {
                  getCollapse(collapse);
               } else if (collapse.type && collapse.type === "item") {
                  if (location.pathname === configs.BASE_NAME + collapse.url) {
                     setItem(collapse);
                  }
               }
               return false;
            });
         }
      };

      navigation.items.map((item) => {
         if (item.type && item.type === "group") {
            getCollapse(item);
         }
         return false;
      });
   }, [location]);

   let breadcrumbContent = "";
   let title = "";

   if (item && item.type === "item") {
      title = item.title;

      if (item.breadcrumbs !== false) {
         breadcrumbContent = (
            <div className="page-header">
               <div className="page-block">
                  <div className="row align-items-center">
                     <div className="col-md-12">
                        <div className="page-header-title">
                           <h5 className="m-b-10">{title}</h5>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         );
      }

      document.title = title + configs.BASE_TITLE;
   }

   return <React.Fragment>{breadcrumbContent}</React.Fragment>;
};

export default Breadcrumb;
